export const share = (message: string) => {
  if (navigator.share) {
    navigator
      .share({
        title: "Check this out!",
        text: "I found this great content!",
        url: message,
      })
      // eslint-disable-next-line no-console
      .then(() => console.log("Link shared successfully"))
      // eslint-disable-next-line no-console
      .catch((error) => console.error("Error sharing link:", error));
  } else {
    alert("Web Share API not supported in this browser");
  }
};
